import React, { useState, useEffect } from 'react';

const EventDetails = () => {
  const [eventData, setEventData] = useState(null);
  const [countdownData, setCountdownData] = useState(null);
  const [doorTime, setDoorTime] = useState('');
  const [loading, setLoading] = useState(true);
  const [conferenceId, setConferenceId] = useState(null);

  const formatDate = (isoDate) => {
    try {
      return new Date(isoDate).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return 'TBD';
    }
  };

  const formatDoorTime = (timeValue) => {
    if (!timeValue) return 'TBD';

    try {
      if (/^\d{2}:\d{2}:\d{2}$/.test(timeValue)) {
        const [hourStr, minute] = timeValue.split(':');
        let hour = parseInt(hourStr, 10);
        const ampm = hour >= 12 ? 'PM' : 'AM';

        hour = hour % 12;
        hour = hour === 0 ? 12 : hour;

        return `${hour}:${minute} ${ampm}`;
      }

      return timeValue;
    } catch {
      return 'TBD';
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const pathname = window.location.pathname;
        const pathParts = pathname.split('/').filter(Boolean);
        const id = pathParts[pathParts.length - 1];

        console.log('Current URL:', pathname);
        console.log('Extracted Conference ID:', id);

        setConferenceId(id);

        if (!id || isNaN(id)) {
          throw new Error('Invalid conference ID in URL');
        }

        const countdownUrl = `https://eventscons.com/eventbackendnew/api/conferences-countdown/${id}`;
        const eventUrl = `https://eventscons.com/eventbackendnew/api/con/time/${id}`;
        const doorTimeUrl = `https://eventscons.com/eventbackendnew/api/conference-doortime/${id}`;

        console.log('Fetching:', { countdownUrl, eventUrl, doorTimeUrl });

        const [countdownResponse, eventResponse, doorTimeResponse] = await Promise.all([
          fetch(countdownUrl),
          fetch(eventUrl),
          fetch(doorTimeUrl)
        ]);

        if (countdownResponse.ok) {
          const countdownResult = await countdownResponse.json();
          setCountdownData(countdownResult.data || null);
        }

        if (eventResponse.ok) {
          const eventResult = await eventResponse.json();

          setEventData({
            start_date: eventResult.start_date,
            end_date: eventResult.end_date,
            location: eventResult.location,
            status: eventResult.status
          });
        } else {
          setEventData({
            start_date: "2026-04-10T00:00:00.000000Z",
            end_date: "2026-04-12T00:00:00.000000Z",
            location: "THE St. REGIS AMMAN HOTELS",
            status: "upcoming"
          });
        }

        if (doorTimeResponse.ok) {
          const doorTimeResult = await doorTimeResponse.json();
          setDoorTime(
            doorTimeResult?.data?.doortime_formatted ||
            doorTimeResult?.data?.doortime ||
            'TBD'
          );
        } else {
          setDoorTime('9:00 AM');
        }

      } catch (err) {
        console.error('API Error:', err);

        setCountdownData({
          days_left: 190,
          hours_left: 12,
          minutes_left: 12,
          seconds_left: 47
        });

        setEventData({
          start_date: "2026-04-10T00:00:00.000000Z",
          end_date: "2026-04-12T00:00:00.000000Z",
          location: "THE St. REGIS AMMAN HOTELS",
          status: "upcoming"
        });

        setDoorTime('9:00 AM');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="event-container">
      <div className="countdown-header">
        <div className="header-title">
          <h2>Event Details</h2>
        </div>
        <div className="countdown-container">
          <div className="countdown-item">
            <span className="countdown-number">{countdownData?.days_left || 190}</span>
            <span className="countdown-label">DAYS</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{countdownData?.hours_left || 19}</span>
            <span className="countdown-label">HOURS</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{countdownData?.minutes_left || 38}</span>
            <span className="countdown-label">MIN</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{countdownData?.seconds_left || 28}</span>
            <span className="countdown-label">SEC</span>
          </div>
        </div>
      </div>

      <div className="event-card">
        <div className="event-item">
          <div className="custom-icon calendar-custom-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM7 12h2v2H7zm6-2h2v6h-2zm2-4h2v2h-2z"/>
            </svg>
          </div>
          <div className="event-content">
            <h3>START DATE</h3>
            <p>{formatDate(eventData?.start_date)}</p>
          </div>
        </div>

        <div className="event-item">
          <div className="custom-icon calendar-custom-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM7 12h2v2H7zm6-2h2v6h-2zm2-4h2v2h-2z"/>
            </svg>
          </div>
          <div className="event-content">
            <h3>END DATE</h3>
            <p>{formatDate(eventData?.end_date)}</p>
          </div>
        </div>

        <div className="event-item">
          <div className="custom-icon door-custom-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-5h-2v4z"/>
            </svg>
          </div>
          <div className="event-content">
            <h3>DOOR TIME</h3>
            <p>{formatDoorTime(doorTime)}</p>
          </div>
        </div>

        <div className="event-item">
          <div className="custom-icon status-custom-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="10"/>
            </svg>
          </div>
          <div className="event-content">
            <h3>STATUS</h3>
            <p>{eventData?.status?.toUpperCase() || 'UPCOMING'}</p>
          </div>
        </div>

        <div className="event-item">
          <div className="custom-icon location-custom-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
            </svg>
          </div>
          <div className="event-content">
            <h3>LOCATION</h3>
            <p>{eventData?.location || 'TBD'}</p>
          </div>
        </div>
      </div>

      <style jsx>{`
        .event-container {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 20px;
        }

        .countdown-header {
          background: white;
          width: 100%;
          max-width: 380px;
        }

        .header-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .header-title h2 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: #2c3e50;
        }

        .countdown-container {
          display: flex;
          justify-content: space-between;
        }

        .countdown-item {
          flex: 1;
          text-align: center;
          padding: 12px 8px;
          background: #AC132E;
          border-right: 1px solid #dcdcdc;
          color: white;
        }

        .countdown-item:last-child {
          border-right: none;
        }

        .countdown-number {
          display: block;
          font-size: 24px;
          font-weight: 700;
          line-height: 1;
        }

        .countdown-label {
          font-size: 10px;
          font-weight: 600;
          text-transform: uppercase;
          margin-top: 4px;
          opacity: 0.9;
        }

        .event-card {
          background: white;
          max-width: 380px;
          width: 100%;
          border: 2px solid transparent;
        }

        .event-item {
          display: flex;
          align-items: center;
          padding: 20px 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .event-item:last-child {
          border-bottom: none;
        }

        .custom-icon {
          width: 48px;
          height: 48px;
          border-radius: 12px;
          border: 2px solid #e74c3c;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 16px;
          color: #e74c3c;
          flex-shrink: 0;
        }

        .custom-icon svg {
          width: 24px;
          height: 24px;
        }

        .calendar-custom-icon {
          border-color: #3498db;
          color: #3498db;
        }

        .door-custom-icon {
          border-color: #f39c12;
          color: #f39c12;
        }

        .status-custom-icon {
          border-color: #e67e22;
          color: #e67e22;
        }

        .location-custom-icon {
          border-color: #9b59b6;
          color: #9b59b6;
        }

        .event-content h3 {
          margin: 0 0 8px 0;
          font-size: 12px;
          font-weight: 600;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .event-content p {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: #2c3e50;
          line-height: 1.4;
          word-break: break-word;
        }

        .loading {
          text-align: center;
          padding: 40px;
          font-size: 18px;
          color: #666;
        }

        @media (max-width: 480px) {
          .countdown-container {
            flex-direction: column;
            gap: 12px;
          }

          .countdown-item {
            padding: 16px 8px;
            border-right: none;
          }
        }
      `}</style>
    </div>
  );
};

export default EventDetails;